
export class RolesAndPermissionsApi {
    email: string;
    firstName: string;
    lastName: string;
    application: ApplicationRoles;
}

export class Policy {
    id: number;
    policyTemplateId: number;
    policyTemplateName: string;
    name: string;
    createdBy: string;
    status: "Active" | "Inactive" | null;
    policies: Policy[];
    roles: Role[];
}

class ApplicationRoles extends Policy {
}

class Role {
    id: number;
    name: string;
    permissions: PermissionGroup[];
}

class PermissionGroup {
    id: number;
    name: string;
    permissions: Permission[];
}

class Permission {
    id: number;
    serviceName: string;
    name: string;
}